import { useSearchParams } from "react-router-dom"

/**
 * @see https://github.com/matsuri-tech/m2m-core-manager-front/pull/2186
 */
export const useBlockCreatePlacementEventFeatureFlag = () => {
    const [searchParams] = useSearchParams()
    return (
        searchParams.get("BLOCK_CREATE_PLACEMENT_EVENT_BY_AUTHORITY") !== null
    )
}
